<template>
    <div class="text-center wow fadeInUp m-4" data-wow-delay="0.1s">
      <h5 class="section-title text-center text-primary text-uppercase">| Ankara Ağrılılar Derneği |</h5>
      <h1 class="mb-4">
        <span class="text-primary text-uppercase">SAYFA BULUNAMADI</span>
      </h1>
      <p class="lead px-3">
        Ankara'da yaşayan <strong>Ağrılı hemşerilerimizin</strong> kurduğu ve işlettiği firmaları sizlerle buluşturuyoruz.
        Bu sayede hem <strong>yerel ekonomiyi</strong> destekliyor hem de <strong>birbirimize güven</strong> duyarak alışveriş yapmanın keyfini yaşıyoruz.
      </p>
      <p class="px-3">
        Burada yer alan firmalar; <strong>Ağrı Merkez</strong> başta olmak üzere <strong>Patnos, Doğubayazıt, Eleşkirt, Diyadin</strong> gibi ilçelerimizden değerli esnaflarımız tarafından Ankara’da kurulmuştur.
      </p>
      <p class="px-3">
        Her biri <strong>kaliteli hizmet</strong>, <strong>dostane yaklaşım</strong> ve <strong>özel hemşeri indirimleri</strong> sunan bu işletmeler, <strong>dernek garantisi</strong>yle listelenmektedir.
      </p>
      <p class="fw-bold px-3 text-success mt-4">
        Siz de işletmenizi bu listeye ekleyerek hemşerilerinizle buluşabilir, ortak gücümüzle daha büyük başarılara imza atabilirsiniz.
      </p>
  
      <!-- Bize Katılın Butonu -->
      <a
        :href="whatsappJoinUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-primary mt-4 px-4 py-2"
      >
      <i class="fab fa-whatsapp fa-lg"></i>
     Bize Katılın
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UnderConst',
    props: {
      msg: String
    },
    data() {
      return {
        whatsappJoinUrl: `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`
      }
    }
  }
  </script>
  
